'use strict';


define('forum/topic/votes', ['api', 'alerts'], function (api, alerts) {
	const Votes = {};

	Votes.toggleVote = function (button, className, delta, type) {
		const post = button.closest('[data-pid]');
		const currentState = post.find('.forum-toolbar ' + className).length;
		const method = currentState ? 'del' : 'put';
		const pid = post.attr('data-pid');

		api[method](`/posts/${pid}/vote`, {
			delta: delta,
		}, function (err) {
			if (err) {
				if (err.message === 'A valid login session was not found. Please log in and try again.') {
					return;
				}
				return alerts.error(err);
			}
			socket.emit('posts.getVotes', { pid: pid }, function (err, s_data) {
				if (err) {
					if (err.message === '[[error:no-privileges]]') {
						return;
					}

					// Only show error if it's an unexpected error.
					return alerts.error(err);
				}

				if (window.tracer && button[0].className) {
					const d = s_data;
					const c = d.content;
					const isVote = (c.items && c.items.length) ? 1 : 0;
					const tags = [];
					post.find('.tag').each((_, e) => {
						tags.push(e.innerText.replace(/^#/, ''));
					});
					const topicE = $(`[component=topic][data-tid=${d.tid}]`);
					window.tracer.track(type === 'upvote' ? 'UpContent' : 'AgainstPost', {
						content_type: post.data('cid') === 1 ? 'moment' : 'post',
						post_theme: $('#topicMainPost .topic-title')[0].innerText,
						tag_list: tags,
						is_text_included: c.value ? 1 : 0,
						is_vote_post: isVote,
						is_image_attached: !isVote && c.imageList && c.imageList.filter(i => i.isImage).length ? 1 : 0,
						is_video_attached: !isVote && (
							(c.videoList || []).length ||
							(c.imageList && c.imageList.filter(i => !i.isImage).length)
						) ? 1 : 0,
						poster_email: topicE.attr('data-email'),
						poster_name: topicE.attr('data-username'),
						poster_time: +topicE.attr('data-timestamp'),
					});
				}
			});
		});

		return false;
	};

	return Votes;
});
